import React from 'react';
import { ArrowDownLeftIcon, ArrowUpRightIcon } from 'lucide-react';
import type { Expediente, Movimiento } from '../../types';
import { diasRestantes, fechaCorta } from '../../utils/fechas';
export function BitacoraPrestamos({
  expediente,
  movimientos
}: {
  expediente: Expediente;
  movimientos: Movimiento[];
}) {
  return <div data-id="element-458" data-mp="15g423fo1g8hq">
      {expediente.prestadoA && expediente.prestadoDesde && <div className="flex flex-wrap items-center justify-between gap-3 border-b border-ambar-100 bg-ambar-50 px-5 py-3" data-id="element-459" data-mp="1t4n63j021z40">
          <div data-id="element-460" data-mp="1y2ot2f0lqikr">
            <p className="text-sm font-semibold text-ambar-700" data-id="element-461" data-mp="1y386pjj7yksz">Expediente fuera de su caja</p>
            <p className="mt-0.5 text-xs text-ambar-700" data-id="element-462" data-mp="1kccwa2t2nvna">
              En poder de {expediente.prestadoA} desde el{' '}
              {fechaCorta(expediente.prestadoDesde)} ·{' '}
              {Math.abs(diasRestantes(expediente.prestadoDesde))} días sin devolver
            </p>
          </div>
          <button type="button" className="h-8 rounded bg-marino-800 px-3 text-xs font-semibold text-white transition-colors duration-150 hover:bg-marino-700" data-id="element-463" data-mp="2gvsmbz9wqteu">
            Registrar devolución
          </button>
        </div>}

      <div className="overflow-x-auto scroll-fino" data-id="element-464" data-mp="335nnbu6w8rt9">
        <table className="w-full min-w-[720px] text-sm" data-id="element-465" data-mp="337721gcwiusx">
          <thead data-id="element-466" data-mp="2ydvrp58vrvw9">
            <tr className="bg-gris-50 text-left text-2xs uppercase tracking-wide text-gris-500" data-id="element-467" data-mp="2ydcjig918lvf">
              <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-468" data-mp="3c48yv5dy76kj">
                Movimiento
              </th>
              <th scope="col" className="px-3 py-2.5 font-semibold" data-id="element-469" data-mp="386jm5tce1nrt">
                Persona
              </th>
              <th scope="col" className="px-3 py-2.5 font-semibold" data-id="element-470" data-mp="3h55dodzu8d4q">
                Fecha
              </th>
              <th scope="col" className="px-3 py-2.5 font-semibold" data-id="element-471" data-mp="1rpywusuflanp">
                Hora
              </th>
              <th scope="col" className="px-5 py-2.5 font-semibold" data-id="element-472" data-mp="1mrnn0i44z05h">
                Motivo
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gris-100" data-id="element-473" data-mp="3muya0frndz8s">
            {movimientos.map(m => <tr key={m.id} className="hover:bg-gris-50" data-id="element-474" data-mp="3rt02tsevlcxg">
                <td className="px-5 py-3" data-id="element-475" data-mp="3vtjyssnpqai0">
                  <span className={`inline-flex items-center gap-2 text-xs font-semibold ${m.tipo === 'Salida' ? 'text-ambar-700' : 'text-exito-700'}`} data-id="element-476" data-mp="3vsifk0wjmhp7">
                    {m.tipo === 'Salida' ? <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-477" data-mp="ekn8cfhy34b2" /> : <ArrowDownLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-478" data-mp="jd6nvi0709ii" />}
                    {m.tipo}
                  </span>
                </td>
                <td className="px-3 py-3 text-xs text-gris-800" data-id="element-479" data-mp="se4jpd0h9aq0">{m.persona}</td>
                <td className="tabular px-3 py-3 text-xs text-gris-700" data-id="element-480" data-mp="xbwk6vf6u55t">{fechaCorta(m.fecha)}</td>
                <td className="tabular px-3 py-3 text-xs text-gris-500" data-id="element-481" data-mp="17g34llousmwj">{m.hora}</td>
                <td className="px-5 py-3 text-xs text-gris-600" data-id="element-482" data-mp="12h9u824v5c0l">{m.motivo}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}